export const USER_ROLE_ENUM = {
  ADMIN: 'ROLE_ADMIN',
  INSIGHT_SUPPORT: 'ROLE_INSIGHT_SUPPORT',
  INSIGHT_USER: 'ROLE_INSIGHT_USER',
  INSIGHT_SALES: 'ROLE_INSIGHT_SALES'
};

export const VALIDATION_TOKEN_ENUM = {
  PASSWORD_RESET: 'PASSWORD_RESET',
  REGISTER_USER: 'REGISTER_USER',
  INVITE_USERS: 'INVITE_USERS'
};

export const USER_ATTRIBUTE_ENUM = {
  LONGITUDE: 'longitude',
  LATITUDE: 'latitude'
};
